import styled from 'styled-components';

export const Page = styled.div`
  width: 100%;
  background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.68) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    var(--default-background-color);
`;
